import { FormattedMessage } from '@edx/frontend-platform/i18n';
import { Button, Icon } from '@openedx/paragon';
import { Launch } from '@openedx/paragon/icons';

import { useCheckoutIntent } from '@/components/app/data';
import EVENT_NAMES from '@/constants/events';
import { sendEnterpriseCheckoutTrackingEvent } from '@/utils/common';

const ReceiptButton: React.FC = () => {
  const { data: checkoutIntent } = useCheckoutIntent();
  const adminBillingUrl = checkoutIntent?.adminPortalUrl
    ? new URL('admin/billing', `${checkoutIntent.adminPortalUrl.replace(/\/$/, '')}/`).toString()
    : null;

  return (
    <Button
      className="w-100 text-primary-500 font-weight-bold"
      variant="outline-primary"
      disabled={!adminBillingUrl}
      href={adminBillingUrl ?? undefined}
      {...(adminBillingUrl ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      onClick={() => sendEnterpriseCheckoutTrackingEvent({
        checkoutIntentId: checkoutIntent?.id ?? null,
        checkoutIntentUuid: checkoutIntent?.uuid ?? null,
        eventName: EVENT_NAMES.SUBSCRIPTION_CHECKOUT.VIEW_RECEIPT_BUTTON_CLICKED,
        properties: {
          adminPortalUrl: adminBillingUrl,
        },
      })}
    >
      <FormattedMessage
        id="components.PurchaseSummary.ReceiptButton.viewReceipt"
        defaultMessage="View Receipt"
        description="Button text to view the receipt for the purchase"
      />
      <Icon src={Launch} className="ml-1 small align-middle" />
    </Button>
  );
};

export default ReceiptButton;
